let IS_WEBP_SUPPORTED = true;
if(typeof document !== 'undefined') {
  IS_WEBP_SUPPORTED = document.createElement('canvas').toDataURL('image/webp').startsWith('data:image/webp');
}

export default IS_WEBP_SUPPORTED;
